import { Col, Image, Row, Stack } from 'react-bootstrap';
import EmptyScreen from 'assets/images/Dashboard/empty.svg';
import { LocaleContext } from 'routes/Router';
import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CommonToast from 'components/commom/CommonToast';
import { FormattedMessage, useIntl } from 'react-intl';
import { getPendingAppointmentsListData } from 'store/pendingAppointments/pendingAppointmentListAction';
import Loader from 'components/commom/Loader';
import { ClearTokenRedirectLogin } from 'utils/general';
import { useNavigate } from 'react-router-dom';
import DefaultImage from 'assets/images/Dashboard/defalut-list.svg';
import moment from 'moment';
import ReusablePagination from 'components/commom/Pagination';
import ReusableButton from 'components/commom/Button';
import CommonModal from 'components/commom/Modal';
import { getProviderListData } from 'store/providerList/providerListAction';
import SelectInputBorder from 'components/commom/SelectInputBorder';
import { internalDoctorCallAPI } from 'store/internalDoctor/internalDoctorAction';

const Appointments = () => {
  const { locale } = useContext(LocaleContext);
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const navigate = useNavigate();
  const intl = useIntl();
  const [appointmentList, setAppointmentList] = useState([]);
  const [providerList, setProviderList] = useState([]);
  const [viewData, setViewData] = useState([]);
  const [internalProvider, setInternalProvider] = useState({
    id: '',
    name: '',
  });
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [isModalActive, setIsModalActive] = useState(false);
  const itemsPerPage = 10;

  const loading = useSelector(
    (state) => state?.getPendingAppointmentsListReducer?.loading
  );
  const internalDoctorloading = useSelector(
    (state) => state?.internalDoctorReducer?.loading
  );
  const providerListLoader = useSelector(
    (state) => state?.providerListReducer?.loading
  );

  useEffect(() => {
    AppointmentsData();
  }, []);

  const AppointmentsData = (pageValue) => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setAppointmentList(res?.data);
        setCount(Math.ceil(res?.count / itemsPerPage));
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getPendingAppointmentsListData(external, pageValue));
  };

  const getProviderList = (appointmentData) => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setProviderList(
          res?.data
            ?.filter((item) => item?.is_internal)
            .map((item) => ({
              id: item?.id,
              name: item?.provider_name,
            }))
        );
        setIsModalActive(true);
        setCount(Math.ceil(res?.count / 10));
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(
      getProviderListData(
        external,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        1,
        appointmentData?.id
      )
    );
  };

  const handlePageChange = async (event, value) => {
    setPage(value);
    AppointmentsData(value);
  };

  const handleAssign = (data) => {
    setInternalProvider({ id: '', name: '' });
    setViewData(data);
    // setIsModalActive(true);
    getProviderList(data);
  };

  const handleCloseModal = () => {
    setIsModalActive(false);
  };

  const handleInputChange = (e) => {
    setInternalProvider(e.target.value);
  };

  const handleSave = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        showToast(res?.message, 'success');
        handleCloseModal();
        AppointmentsData();
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    const body = {
      doctor_id: internalProvider?.id,
      appointment_id: viewData?.booking_id,
    };
    dispatch(internalDoctorCallAPI(external, body));
  };

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0">
        <Col
          className={
            locale === 'en'
              ? 'commonEnContainer lg:ml-left border-l bColor-EFE3D7'
              : 'commonArContainer lg:mr-right border-l bColor-EFE3D7'
          }
        >
          <h2 className="fc-292D32 fs-32 family_outfit_semiBold_600 lh-4032  m-0">
            <FormattedMessage id="Appointments" />
          </h2>
          {loading ? (
            <Loader />
          ) : appointmentList && appointmentList.length > 0 ? (
            <div className="pt-20">
              <Row className="listCustomHeader m-0 p-0 flex items-center">
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    <FormattedMessage id="Patient & ID" />
                  </p>
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    <FormattedMessage id="Provider" />
                  </p>
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    <FormattedMessage id="Consultation mode" />
                  </p>
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    <FormattedMessage id="Booking ID" />
                  </p>
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    <FormattedMessage id="Date & Time" />
                  </p>
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    {/* <FormattedMessage id="" /> */}
                  </p>
                </Col>
              </Row>
              <Row className="bc-FFFFFF m-0 p-0">
                {appointmentList.map((item, index) => {
                  return (
                    <Row className="m-0 p-0 flex items-center listAppointment">
                      <Col lg={2} md={6} sm={12}>
                        <Stack
                          direction="horizontal"
                          gap={2}
                          className="flex items-center"
                        >
                          <Image
                            src={
                              item?.patient?.profile_pic !== ''
                                ? item?.patient?.profile_pic
                                : DefaultImage
                            }
                            alt={'icon'}
                            style={{
                              height: '40px',
                              width: '40px',
                              borderRadius: '50%',
                            }}
                          />
                          <div>
                            <div className="fs-14 fc-202224 lh-1512 family_outfit_semiBold_600">
                              {item?.patient?.full_name}
                            </div>
                            <div className="fs-12 fc-202224 family_outfit_regular_400 pt-04 lh-1512">
                              {item?.patient?.patient_id}
                            </div>
                          </div>
                        </Stack>
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <Stack
                          direction="horizontal"
                          gap={2}
                          className="flex items-center"
                        >
                          <Image
                            src={
                              item?.doctor?.profile_image !== ''
                                ? item?.doctor?.profile_image
                                : DefaultImage
                            }
                            alt={'icon'}
                            style={{
                              height: '40px',
                              width: '40px',
                              borderRadius: '50%',
                            }}
                          />
                          <div>
                            <div className="fs-14 fc-202224 lh-1512 family_outfit_semiBold_600">
                              {item?.doctor?.name}
                            </div>
                            <div className="fs-12 fc-202224 family_outfit_regular_400 pt-04 lh-1512">
                              {item?.doctor?.id}
                            </div>
                          </div>
                        </Stack>
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <div className="fs-14 fc-202224 family_outfit_regular_400 lh-1512">
                          {item?.consultation_type}
                        </div>
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <div className="fs-14 fc-202224 family_outfit_regular_400 lh-1512 break-all ...">
                          {item?.booking_id}
                        </div>
                      </Col>
                      <Col md={6} lg={2}>
                        <div className="fs-14 fc-202224 lh-1512 family_outfit_regular_400 break-all ...">
                          {moment(item?.appointment_date_time).format(
                            'DD MMM YYYY'
                          )}
                          <br />
                          <span className="fs-14 fc-202224 lh-1512 family_outfit_regular_400 break-all ...">
                            {moment(item?.appointment_date_time).format(
                              'hh:mmA'
                            )}
                          </span>
                        </div>
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <div className="fs-14 fc-202224 family_outfit_regular_400 lh-1512 break-all ...">
                          <ReusableButton
                            fullWidth={false}
                            variant="contained"
                            color="#F5F5F5"
                            fontSize="14px"
                            fontWeight="500"
                            padding="12px 50px"
                            height="44px"
                            bgColor="#375241"
                            brColor="#375241"
                            fontFamily="outfit_medium"
                            onClick={() => {
                              handleAssign(item);
                            }}
                            loading={providerListLoader}
                          >
                            <FormattedMessage id="Assign" />
                          </ReusableButton>
                        </div>
                      </Col>
                    </Row>
                  );
                })}
              </Row>
            </div>
          ) : (
            <div className="flex justify-center pt-120">
              <div>
                <Image src={EmptyScreen} alt="icon" />
                <div className="fs-20 fc-3C3C3C lh-2 family_outfit_medium_500 text-center	pt-30">
                  Nothing here yet
                </div>
              </div>
            </div>
          )}
          {count > 1 && (
            <Col sm={12} className="flex justify-end mt-10 p-0">
              <ReusablePagination
                count={count}
                page={page}
                showFirstButton
                showLastButton
                onChange={(event, value) => handlePageChange(event, value)}
                borderColor="#00000"
                textColor="#00000"
                selectedBgColor="#EBEBE4"
                selectedTextColor="#00000"
                selectedBorderColor="#00000"
                ellipsisBorder="none"
                borderWidth="2px"
                borderStyle="dashed"
              />
            </Col>
          )}
        </Col>
      </Row>

      <CommonModal
        padding={'24px'}
        width={'500px'}
        modalActive={isModalActive}
        innerContent={
          <div>
            <Row>
              <Col xs={12}>
                <div className="fs-24 pt-8 sm:pt-24 family_outfit_semiBold_600">
                  Internal Doctor
                </div>
                {/* <div className="mt-16 fs-16 family_outfit_regular_400 lh-208 fc-7B998A pt-12">
                  Do you want to approve this doctor as an internal doctor or
                  external doctor?
                </div> */}
                <div className="pt-20">
                  <SelectInputBorder
                    placeholder={intl.formatMessage({
                      id: 'Select Doctor',
                    })}
                    name={internalProvider}
                    value={internalProvider?.name}
                    data={providerList}
                    onChange={(e) => handleInputChange(e)}
                    background={'#FFFFFF'}
                    // width={'276px'}
                    colorIcon={'#292D32'}
                    // placeholderColor={'#292D32'}
                  />
                </div>
              </Col>
              <Col xs={12} md={12} className="mt-5 flex">
                <Stack
                  direction="horizontal"
                  gap={2}
                  className="items-center justify-end p-0 w-full"
                >
                  <ReusableButton
                    fullWidth={true}
                    variant="outlined"
                    color="#3C3C3C"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="transparent"
                    brColor="#EFE3D7"
                    fontFamily="outfit_medium"
                    onClick={() => handleCloseModal()}
                  >
                    Cancel
                  </ReusableButton>

                  <ReusableButton
                    fullWidth={true}
                    variant="contained"
                    color="#F5F5F5"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="#375241"
                    brColor="#375241"
                    fontFamily="outfit_medium"
                    onClick={() => {
                      !internalDoctorloading && handleSave();
                    }}
                    loading={internalDoctorloading}
                  >
                    Save
                  </ReusableButton>
                </Stack>
              </Col>
            </Row>
          </div>
        }
      />
    </div>
  );
};

export default Appointments;
